// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"105":"0e051de2","608":"70fb2528","787":"1c435681"}[chunkId] + ".chunk.js";
};